import CrudRequest from '@/app/arch/components/crud/CrudRequest';
import httpService from '@/app/arch/services/HttpService';

class TemplateRequest extends CrudRequest {
  static baseUrl() {
    return '/produto-servico/template';
  }

  static save(payload) {
    return httpService.post(`${this.baseUrl()}/add`, payload);
  }

  static list(params = {}) {
    return httpService.get(`${this.baseUrl()}/list-all`, {
      params,
    });
  }
}

export default TemplateRequest;
